<template>
  <div class="stream-links">
    <h2 class="subtitle">Sudjeluj online</h2>
    <p class="description">Odaberi platformu s koje ćeš pratiti predavanja i panel rasprave</p>
    <div class="buttons-wrapper">
      <a class="button-youtube" :href="youtubeLink" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/app-icons/home/youtube.svg" />Prati stream
      </a>
      <a class="button-discord" :href="discordLink" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/app-icons/home/discord.svg" />Pridruži se
      </a>
    </div>
  </div>
</template>

<script>
import { youtubeLinkDay1, youtubeLinkDay2, discordLink } from '@/config';

export default {
  name: 'StreamLinks',
  data() {
    return {
      youtubeLinkDay1,
      youtubeLinkDay2,
      discordLink,
    };
  },
  computed: {
    youtubeLink() {
      const day = new Date().getDate();

      return day === 15 ? youtubeLinkDay2 : youtubeLinkDay1;
    },
  },
};
</script>

<style scoped>
.stream-links {
  padding-top: 48px;
}

.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 8px;
}

.description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
  margin-bottom: 24px;
  max-width: 400px;
}

.buttons-wrapper {
  display: flex;
  align-items: center;
}

.button-youtube {
  border: 1px solid #30cec2;
  background: #30cec2;
  border-radius: 15px;
  padding: 12px 32px;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  cursor: pointer;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.button-discord {
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: transparent;
  border-radius: 15px;
  padding: 12px 32px;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: white;
  cursor: pointer;
  display: inline-flex;
  text-decoration: none;
  align-items: center;
}

.button-youtube img,
.button-discord img {
  margin-right: 8px;
}

@media screen and (max-width: 768px) {
  .buttons-wrapper {
    flex-direction: column;
    align-items: baseline;
    margin-bottom: 40px;
  }

  .buttons-wrapper > a {
    width: 125px;
    margin: 0;
    margin-bottom: 16px;
  }
}
</style>
